// extracted by mini-css-extract-plugin
module.exports = {"transition":"styles_transition__1Q-xl","rotation":"styles_rotation__1nKUV"};